<div [formGroup]="form"
     [kalLoading]="loading">

    <ng-container *ngIf="shouldDisplayInterActivityRulePicker">

        <kal-form-field>
            <kal-radio-group formControlName="IsTransverse"
                             label="Type de règle">
                <kal-radio [value]="false">Créer une nouvelle règle</kal-radio>
                <kal-radio [value]="true">Contrôler une règle inter-activité</kal-radio>
            </kal-radio-group>
        </kal-form-field>

        <kal-form-field *ngIf="form.get('IsTransverse').value">
            <kal-select disableFirstOptionSelection
                        formControlName="Id"
                        label="Règles d'inter-activités"
                        placeholder="Sélectionner une règle inter-activité">
                <kal-option *ngFor="let rule of interActivityRuleList"
                            [value]="rule.Id">{{rule.LibelleRegle}}</kal-option>
            </kal-select>
        </kal-form-field>

        <div class="gup-O-separationLine"></div>

    </ng-container>

    <kal-form-field>
        <kal-input formControlName="Libelle"
                   label="Libellé de la règle">
        </kal-input>
    </kal-form-field>

    <ng-container [ngSwitch]="selectedRuleType">

        <ng-container *ngSwitchCase="ruleTypeEnum.Enveloppe">

            <div *ngIf="isInterActivity">

                <kal-checkbox class="gup-U-margin-bottom--mini"
                              formControlName="IsComplementaire"
                              kalTheme="switch"
                              label="Enveloppe complémentaire">
                </kal-checkbox>

                <ul class="gup-U-color--400">

                    <li class="gup-U-margin-bottom--small">La {{'' + activityType | i18nSelect:  {
                        EPA: 'abondement',
                        other: 'subvention'
                    } }} accordée sur cette
                        enveloppe complémentaire est :
                    </li>
                    <li class="gup-U-margin-bottom--mini">- Soumise au choix du bénéficiaire, qui pourra décider de ne
                        pas la prendre sur l’opération
                        en cours.
                    </li>
                    <li class="gup-U-margin-bottom--normal">- Attribuée en complément des
                        autres {{'' + activityType | i18nSelect:  {
                            EPA: 'abondement',
                            other: 'subvention'
                        } }}s qui pourraient être présentes.
                    </li>
                </ul>
            </div>
        </ng-container>

        <ng-container *ngSwitchCase="ruleTypeEnum.Quota">
            <ng-container *ngTemplateOutlet="quotaTemplate"></ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="ruleTypeEnum.QuotaFaciale">
            <ng-container *ngTemplateOutlet="quotaTemplate"></ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="ruleTypeEnum.QuotaNombre">
            <ng-container *ngTemplateOutlet="quotaTemplate"></ng-container>
        </ng-container>

        <ng-container *ngIf="shouldShowSubventionTypeSelect && !isAllocationContext">

            <ng-container *ngSwitchCase="ruleTypeEnum.Subvention">

                <kal-form-field class="gup-C-formFieldSize--select">

                    <kal-select class="gup-U-margin-bottom--normal"
                                disableFirstOptionSelection
                                formControlName="IsSubventionEnveloppeComplementaire"
                                label="Type de règle">
                        <kal-option *ngIf="!hasId || !isComplementaryEnvelopSubvention"
                                    [value]="false">
                            {{'' + activityType | i18nSelect: subventionLabeli18nSelect }}
                        </kal-option>
                        <kal-option *ngIf="!hasId || isComplementaryEnvelopSubvention"
                                    [value]="true">
                            {{'' + activityType | i18nSelect: subventionLabeli18nSelect }} complémentaire
                        </kal-option>
                    </kal-select>

                    <kal-form-field *ngIf="isComplementaryEnvelopSubvention">
                        <kal-select *ngIf="(complementaryEnvelopeList | arrayNotEmpty); else noEnvelopeTemplate"
                                    formControlName="IdEnveloppeComplementaire"
                                    label="Enveloppe complémentaire">
                            <kal-option *ngFor="let envelope of complementaryEnvelopeList"
                                        [value]="envelope.Id">{{envelope.Libelle}}</kal-option>
                        </kal-select>
                    </kal-form-field>

                    <ng-template #noEnvelopeTemplate>
                        <p class="gup-U-color--red">Aucune enveloppe complémentaire n'est paramétrée</p>
                    </ng-template>

                    <kal-form-field *ngIf="isComplementaryEnvelopSubvention">
                        <kal-input formControlName="Ordre"
                                   label="Ordre">
                        </kal-input>
                    </kal-form-field>

                </kal-form-field>

            </ng-container>

        </ng-container>

        <ng-template #quotaTemplate>
            <kal-form-field *ngIf="!isMediaOrResourcesActivity">
                <kal-radio-group formControlName="TypeRegle"
                                 label="Quota défini">
                    <kal-radio [value]="ruleTypeEnum.QuotaNombre">En nombre</kal-radio>
                    <kal-radio [value]="ruleTypeEnum.QuotaFaciale">En valeur faciale</kal-radio>
                </kal-radio-group>
            </kal-form-field>
        </ng-template>

    </ng-container>

    <div *ngIf="!isMedia"
         class="gup-U-margin-bottom--normal">
        <kal-checkbox formControlName="IsForcageAutorise"
                      kalTheme="switch"
                      label="Autoriser le forçage">
        </kal-checkbox>
        <p class="gup-U-color--400">En autorisant le forçage, vous autorisez l’attribution à des bénéficiaires qui ne
            font pas partie de la cible de base, à condition qu’il n’y ait pas d’autres règles.</p>
    </div>

    <div *ngIf="!isMediaOrBenefitsActivity"
         class="gup-U-margin-bottom--normal">
        <kal-checkbox formControlName="IsVenteSansSubAutorise"
                      kalTheme="switch"
                      label="Autoriser la vente sans subvention"></kal-checkbox>
        <p class="gup-U-color--400">En autorisant la vente sans subvention, vous autorisez la vente d’un article à
            un bénéficiaire sans que celui-ci soit subventionné.</p>
    </div>


    <!-- Tableau   -->
    <app-shared-advanced-rule-edit-table [ruleType]="selectedRuleType"
                                         formControlName="ReglesEnfants">
    </app-shared-advanced-rule-edit-table>

    <div *ngIf="isSubventionRule">

        <kal-form-field>
            <kal-radio-group formControlName="TypeSP"
                             label="Arrondi">
                <kal-radio [value]="null">Aucun</kal-radio>
                <kal-radio value="S">{{ '' + activityType | i18nSelect: subventionLabeli18nSelect }}</kal-radio>
                <kal-radio value="P">Prix Final</kal-radio>
            </kal-radio-group>
        </kal-form-field>

        <div class="flexLine">
            <kal-form-field>
                <kal-select formControlName="TypeArrondi"
                            label="Type d'arrondi">
                    <kal-option *ngFor="let rounding of roundingTypes[selectedRoundingType]?.roundingType || []"
                                [value]="rounding">{{rounding | i18nSelect: roundingI18nSelect }}</kal-option>
                </kal-select>
            </kal-form-field>

            <kal-form-field>
                <kal-select formControlName="Precision"
                            label="Précision">
                    <kal-option *ngFor="let precision of roundingTypes[selectedRoundingType]?.precision || []"
                                [value]="precision">{{precision}}</kal-option>
                </kal-select>
            </kal-form-field>
        </div>
    </div>

</div>
